import axios from "axios";
import React, { useEffect, useState } from "react";
import { serverLink, shortCode } from "../../../resources/url";
import Loader from "../../common/loader/loader";
import PageName from "../../common/pagename/pagename";
import Banner from "../../common/banner/banner";
import LeadershipProfileModal from "./profile-modal/modal";
import ProfilePage from "./profile-modal/profile-page";
import {Link} from "react-router-dom";
import {Button, Modal} from "react-bootstrap";
import * as DOMPurify from 'dompurify';


const Management = () => {
    const [management, setManagement] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showApplicationModal, setShowApplicationModal] = useState(false);

    const handleCloseApplicationModal = () => setShowApplicationModal(false);
    const handleShowApplicationModal = () => setShowApplicationModal(true);
    const [boardmember, setMember] = useState({})
    useEffect(() => {
        async function getManagement() {
            const result = await axios.get(`${serverLink}leadership/management/list`);
            setManagement(result.data);
            setLoading(false);
        }
        getManagement();
    }, []);

    const [members, setMembers] = useState({})
    return (
        <>
            {loading ? <Loader /> : ""}
            <PageName page={"Management"} />

            <Banner
                Title={"Management"}
                breadcrumb={["Home", "Management"]}
            />
            <div className="container mb-5 pb-3">
                <div className="col-12">
                    <h3 className="text-center my-5">Management</h3>
                    <div className="d-flex align-items-center align-content-between flex-column">
                        <div className="row">
                            {management.map((member, index) => (
                                <div
                                    className={`text-center ${index === 0 ? "col-md-12 d-block" : "col-md-4"
                                    }  `}
                                    key={index}
                                >
                                    <img
                                        src={member.ImagePath !== null ? member.ImagePath.includes("simplefileupload") ? member.ImagePath :  `${serverLink}public/uploads/${shortCode}/leaderships_uploads/${member.ImagePath}` : ""}
                                        
                                        alt={member.FullName}
                                        className="img-thumbnail"
                                        style={{
                                            height: 400,
                                            width: 400,
                                        }}
                                     />
                                    <h4 className="my-2">
                                        {member.Title} {member.FullName}
                                    </h4>
                                    <h5 >{member.Designation}</h5>

                                    <p style={{ cursor: 'pointer'}} className="text-center mb-5" data-bs-toggle="modal" data-bs-target="#pModal" onClick={() => {
                                        handleShowApplicationModal();
                                        setMember(member)
                                    }}>View profile</p>

                                </div>

                            ))}
                        </div>
                        <Modal
                            show={showApplicationModal}
                            onHide={handleCloseApplicationModal}
                            size="lg"
                        >
                            <Modal.Header >
                                <Modal.Title> {boardmember.Title} {boardmember.FullName}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="" style={{textAlign:'justify' }}>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(boardmember.Description),
                                        }}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="danger" onClick={handleCloseApplicationModal}>
                                    Close
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Management;